import { CookieHelper, HashHelper, StringHelper } from '../helpers'
import { AuthModule, ApplicationModule } from '../store'
import { SEGMENT, VEHICLE_TYPE } from '../const'

function listenCookieChange(callback: Function, interval:number = 1000) {
	let lastCookie = document.cookie;
	setInterval(()=> {
		let cookie = document.cookie;
		if (cookie !== lastCookie) {
			try {
				callback({oldValue: lastCookie, newValue: cookie});
			} finally {
				lastCookie = cookie;
			}
		}
	}, interval);
}

function setCookie(name:string, value:any, daysToLive:number) {
	// Encode value in order to escape semicolons, commas, and whitespace
	var cookie = name + "=" + encodeURIComponent(value);

	if(typeof daysToLive === "number") {
		/* Sets the max-age attribute so that the cookie expires
		after the specified number of days */
		cookie += "; domain=.carfinance247.co.uk; max-age=" + (daysToLive*24*60*60);

		document.cookie = cookie;
	}
}

export default {
    checkSegmentLoaded() {
        return new Promise((resolve, reject) => {
			setTimeout(()=>{
				if(segmentCheckingInterval) {
					(window as any).clearInterval(segmentCheckingInterval);
					(window as any).segmentLoaded = false;
					reject(false);
				}
			}, 60000);
            var segmentCheckingInterval:number | undefined = (window as any).setInterval(() => {
                if ( (window as any).analytics ) {
                    (window as any).clearInterval(segmentCheckingInterval);
					segmentCheckingInterval = undefined;
                    (window as any).segmentLoaded = true;
                    resolve(true);
                }
            }, 500);
          });
    },
  initSegment () {
    if ((window as any).analytics) {
			let isProduction = AuthModule.isProduction;

      const segmentKey = isProduction ? SEGMENT.PROD_KEY : SEGMENT.DEV_KEY;

			const delegateFunction = () => {
				const domainCookieAdvertisement = CookieHelper.get('cookieyes-advertisement');
				const domainCookieFunctional = CookieHelper.get('cookieyes-functional');
				const domainCookieNecessary = CookieHelper.get('cookieyes-necessary');
				const domainCookieOther = CookieHelper.get('cookieyes-other');
				const domainCookieAnalytics = CookieHelper.get('cookieyes-analytics');
				const domainCookiePerformance = CookieHelper.get('cookieyes-performance');

				const cookieyesShowed = CookieHelper.get('cookieyesShowed');

				if(cookieyesShowed === '1') {
					(window as any).analytics.load(segmentKey, {
						integrations: {
							'All': true,
							'Google Tag Manager': domainCookieNecessary === 'yes',
							'Braze Cloud Mode (Actions)': domainCookieNecessary === 'yes'
						}
					});
				}

				// @ts-ignore
				listenCookieChange(({oldValue, newValue})=> {
					const oldCookieAdvertisement = CookieHelper.getCookieValue(oldValue, 'cookieyes-advertisement');
					const oldCookieFunctional = CookieHelper.getCookieValue(oldValue, 'cookieyes-functional');
					const oldCookieNecessary = CookieHelper.getCookieValue(oldValue, 'cookieyes-necessary');
					const oldCookieOther = CookieHelper.getCookieValue(oldValue, 'cookieyes-other');
					const oldCookieAnalytics = CookieHelper.getCookieValue(oldValue, 'cookieyes-analytics');
					const oldCookiePerformance = CookieHelper.getCookieValue(oldValue, 'cookieyes-performance');

					const newCookieAdvertisement = CookieHelper.getCookieValue(newValue, 'cookieyes-advertisement');
					const newCookieFunctional = CookieHelper.getCookieValue(newValue, 'cookieyes-functional');
					const newCookieNecessary = CookieHelper.getCookieValue(newValue, 'cookieyes-necessary');
					const newCookieOther = CookieHelper.getCookieValue(newValue, 'cookieyes-other');
					const newCookieAnalytics = CookieHelper.getCookieValue(newValue, 'cookieyes-analytics');
					const newCookiePerformance = CookieHelper.getCookieValue(newValue, 'cookieyes-performance');

					if (oldCookieAdvertisement !== newCookieAdvertisement ||
						oldCookieFunctional !== newCookieFunctional ||
						oldCookieNecessary !== newCookieNecessary ||
						oldCookieOther !== newCookieOther ||
						oldCookieAnalytics !== newCookieAnalytics ||
						oldCookiePerformance !== newCookiePerformance) {
						if (oldCookieAdvertisement && oldCookieFunctional && oldCookieNecessary && oldCookieOther && oldCookieAnalytics && oldCookiePerformance) {
							(window as any).analytics.load(segmentKey, {
								integrations: {
									'All': true,
									'Google Tag Manager': newCookieNecessary === 'yes',
									'Braze Cloud Mode (Actions)': newCookieNecessary === 'yes'
								}
							});

							setCookie('cookieyesShowed', 1, 365);
						}
					}
				}, 1000);
			};

			delegateFunction();

    }
  },
  trackApplicationFormStart (obj: any) {
    if ((window as any).analytics) {
      (window as any).analytics.page('application', 'Application Form Started', {
        loan_submission_guid: obj.guid
      })
    }
  },
  trackPage(guid: string, pageName: string) {
		if ((window as any).analytics && (window as any).segmentLoaded ) {
			(window as any).analytics.page("application", "Application Page Change to " + pageName, {
				"loan_submission_guid": guid
			});
		}
	},
  trackPersonalDetailsCompletedEvent (obj: any) {
    const tracksData: any = {}

    const fbp = CookieHelper.get('_fbp')

    if (fbp) {
      tracksData.fb_browser_id = fbp.split('.').slice(-2).join('.')
    }

    const ga = CookieHelper.get('_ga')

    if (ga) {
      tracksData.ga_client_id = ga.split('.').slice(-2).join('.')
    }

    tracksData.loan_submission_guid = obj.guid

		const email_address = StringHelper.toLowerCaseAndTrim(obj.email);

		tracksData.date_of_birth = obj.date_of_birth;
		tracksData.email_address = email_address;
		tracksData.email = email_address;
		tracksData.first_name = StringHelper.toLowerCaseAndTrim(obj.first_name);
		tracksData.last_name = StringHelper.toLowerCaseAndTrim(obj.last_name);
		tracksData.phone_number_normalised = obj.phone_number_normalised;
		tracksData.postcode = StringHelper.toLowerCaseAndTrimAndRemoveAllSpaces(obj.postcode);

		let gclid:any = '';

		if (obj && obj.utm) {
			tracksData.agentPublicId = StringHelper.toLowerCaseAndTrim(obj.utm.agentPublicId ?? null);
			tracksData.utm_campaign = StringHelper.toLowerCaseAndTrim(obj.utm.campaign ?? null);
			tracksData.utm_content = StringHelper.toLowerCaseAndTrim(obj.utm.content ?? null);
			tracksData.utm_medium = StringHelper.toLowerCaseAndTrim(obj.utm.medium ?? null);
			tracksData.mkwid = StringHelper.toLowerCaseAndTrim(obj.utm.mkwid ?? null);
			tracksData.rai = StringHelper.toLowerCaseAndTrim(obj.utm.referrerApplicationId ?? null);
			tracksData.utm_sid = StringHelper.toLowerCaseAndTrim(obj.utm.sid ?? null);
			tracksData.utm_source = StringHelper.toLowerCaseAndTrim(obj.utm.source ?? null);
			tracksData.utm_term = StringHelper.toLowerCaseAndTrim(obj.utm.term ?? null);
			tracksData.utm_type = StringHelper.toLowerCaseAndTrim(obj.utm.type ?? null);
			tracksData.cid = StringHelper.toLowerCaseAndTrim(obj.utm.cid ?? null);

			gclid = obj.utm.gclid ?? '';
		}

		tracksData.net_monthly_income = Number(obj.net_monthly_income);
		tracksData.city = StringHelper.toLowerCaseAndTrimAndRemoveAllSpaces(obj.city);
		tracksData.gender = StringHelper.toLowerCaseAndTrimAndRemoveAllSpaces(obj.gender);

		type VEHICLE_TYPE_KEY = keyof typeof VEHICLE_TYPE

		const vehicle_type = Object.keys(VEHICLE_TYPE).find(key => VEHICLE_TYPE[key as VEHICLE_TYPE_KEY] === obj.vehicle_type_id);

		if (vehicle_type) {
			tracksData.vehicle_type =  StringHelper.toLowerCaseAndTrim(vehicle_type);
		}

		const submission_hostname = StringHelper.toLowerCaseAndTrim(ApplicationModule.urlReferrer);

		tracksData.submission_hostname = submission_hostname;

    if ((window as any).analytics) {
      (window as any).analytics.track('Personal Details Completed', tracksData)

			const id = email_address;

			const identifyData = {
				date_of_birth: tracksData.date_of_birth,
				email_address: tracksData.email_address,
				email: tracksData.email_address,
				first_name: tracksData.first_name,
				last_name: tracksData.last_name,
				phone_number_normalised: tracksData.phone_number_normalised,
				postcode: tracksData.postcode,
				submission_hostname: tracksData.submission_hostname,
				_gclid: gclid
			}

      HashHelper.sha256(id).then(hash_result => {
        (window as any).analytics.identify(hash_result, identifyData)
      })
    }

    if ((window as any).dataLayer) {
      tracksData.category = 'application'
      tracksData.event_name = 'Personal Details Completed';

      (window as any).dataLayer.push(tracksData)
    }
  }
}
